<template>
  <BaseSearchDetails/>
</template>
<script>
import BaseSearchDetails from 'operations/knowledgeBase/baseSearchDetails.vue'
export default {
    components:{
      BaseSearchDetails
    }
}
</script>